import { gql } from '@apollo/client';

/**
 * Query to fetch user's experimental applications
 * Fetches all applications where the user has a role and status is "Experimental"
 */
export const ExperimentalAppsQuery = gql`
  query ExperimentalApps(
    $login: String!
    $filter: ResourceCatalogUserApplicationFilter
    $pagination: PaginationInput
    $sortBy: ResourceCatalogApplicationSortByInput
  ) {
    identity {
      user(login: $login) {
        login
        email
        resources {
          applicationsPaged(
            filter: $filter
            pagination: $pagination
            sortBy: $sortBy
          ) {
            applications {
              applicationId
              name
              description
              status
              owner {
                displayName
                email
                firstName
                lastName
              }
              corporateEntity
              updatedAt
              createdAt
              resources {
                adGroupsPaged {
                  totalCount
                  adGroups {
                    groupId
                    groupName
                    description
                  }
                }
              }
            }
            totalCount
          }
        }
      }
    }
  }
`;
